import { State } from '.';
import { defaultInitRules, defaultPatchRules, Gear } from './Gear';
import { buildClassName, DomNode } from './render';
import { DefaultRules } from './rules';
export const defaultHtmlInitRules = Object.assign({ css: DefaultRules.StringArray }, defaultInitRules);
export const defaultHtmlPatchRules = Object.assign({ css: DefaultRules.StringArray }, defaultPatchRules);
export const defaultHtmlFactory = (opts, context, scope, rules) => {
    return new Html(opts, context, scope);
};
export const defaultRender = (html) => (html.render) ? html.render() : html;
export const passthruLayout = (factory, key, props, dom, children) => {
    return children && children.map(defaultRender);
};
export const defaultLayout = (factory, key, props, dom, children, changes) => {
    return factory.createVNode(key, props, dom, children && children.map(defaultRender), changes);
};
export class Html extends Gear {
    //    ext: HtmlProps
    constructor(options, context, scope) {
        super(options, context, scope);
        this.scope.$dom = new DomNode(this.scope.$renderer);
        //        this.ext = {}
        //        this.dirty = true
    }
    patch(optPatch) {
        super.patch(optPatch);
        // if (this.state == State.Destroying || this.state == State.Destroyed) {
        //     return
        // }
        const o = this.options;
        // TODO
        const dom = this.scope.$dom;
        if (optPatch.classes) {
            dom.className = buildClassName(dom.className, o.classes);
        }
        if (optPatch.css) {
            dom.className = buildClassName(dom.className, o.css);
        }
        if (optPatch.styles) {
            dom.styles = Object.assign(Object.assign({}, dom.styles), o.styles);
        }
        if (optPatch.html) {
            dom.html = o.html;
        }
        if (optPatch.tag != null) {
            dom.tag = o.tag;
        }
        if (!this.changes) {
            this.changes = {};
        }
        // if (optPatch.items || optPatch.components || optPatch.templates || optPatch.defaultItem || optPatch.defaultComponent) {
        //     this.changes.structure = true
        // }
        // if (optPatch.weight != null) {
        //     if (this.parent) {
        //         if (!this.parent.changes) {
        //             this.parent.changes = {}
        //         }
        //         this.parent.changes.structure = true
        //     }
        // }
        if (optPatch.tag) {
            this.changes.tag = optPatch.tag;
        }
        if (optPatch.html) {
            this.changes.html = optPatch.html;
        }
        if (optPatch.styles) {
            this.changes.styles = Object.assign(Object.assign({}, this.changes.styles), optPatch.styles);
        }
        if (optPatch.classes) {
            this.changes.classes = this.changes.classes || {};
            for (let i in optPatch.classes) {
                this.changes.classes[i] = this.options.classes[i];
            }
            //            this.changes.classes = {...this.changes.classes, ...optPatch.classes}// buildClassName(this.changes.className, optPatch.classes)
        }
        if (optPatch.css) {
            if (optPatch.css) {
                this.changes.classes = this.changes.classes || {};
                if (Array.isArray(optPatch.css)) {
                    optPatch.css.forEach(css => {
                        css.split(' ').forEach(cn => {
                            this.changes.classes[cn] = true;
                        });
                    });
                }
                else {
                    optPatch.css.split(' ').forEach(cn => {
                        this.changes.classes[cn] = true;
                    });
                }
            }
            //this.changes.className = buildClassName(this.changes.className, optPatch.css)
        }
        // помечаем путь до корня "грязным"
        let html = this;
        while (html && !html.dirty) {
            html.dirty = true;
            //            if (!html.parent) {
            if (html.isRoot) {
                //                debugger
                // планируем перерисовку в свой такт (после всех патчей)
                //html.scope.$engine.publish(html.scope.$renderer.task(null))
                html.scope.$pipe.push(html.scope.$renderer.effect(null));
                //                break
            }
            html = html.parent;
        }
        // this.visit((h) => {
        //     if (h.dirty) return false
        //     h.dirty = true
        // })
    }
    initRules() {
        return defaultHtmlInitRules;
    }
    patchRules() {
        return defaultHtmlPatchRules;
    }
    attach(root) {
        this.scope.$renderer.attach(root, this);
        this.attached = true;
    }
    detach() {
        this.scope.$renderer.detach(this);
        this.attached = false;
    }
    get isRoot() {
        return this.parent ? (this.parent.scope.$renderer != this.scope.$renderer) : true;
    }
    render(asRoot) {
        if (this.state == State.Destroyed) {
            return null;
        }
        if (!asRoot && this.isRoot) {
            return null;
        }
        if (this.options.render === false) {
            return null;
        }
        if (!this.dirty) {
            return this.vnode;
        }
        const o = this.options;
        const layout = o.layout || this.scope.$defaultLayout;
        //        const renderer: Renderer = this.scope.$renderer
        const factory = this.scope.$renderer; //.$vnodeFactory
        const dom = this.scope.$dom;
        const text = o.text;
        const children = this.children;
        const key = this.uid || this.key || this.index;
        // if (key != null) {
        //     ext.key = key
        // }
        if (text || children.length > 0) {
            let childrenAndText = children;
            if (text) {
                childrenAndText = [...children];
                const i = children.findIndex(c => !c.options.weight || c.options.weight >= 0);
                if (i == -1) {
                    childrenAndText.push(text);
                }
                else {
                    childrenAndText.splice(i, 0, text);
                }
            }
            this.vnode = layout(factory, key, this.options.dom, dom, childrenAndText, this.changes);
        }
        else {
            this.vnode = layout(factory, key, this.options.dom, dom, undefined, this.changes);
        }
        //        (dom as any).$applyEffects(this.scope.$renderer)
        this.dirty = false;
        //        console.log('changes', this.changes)
        this.changes = null;
        return this.vnode;
    }
    destroy(defer) {
        super.destroy(() => {
            if (this.attached) {
                this.detach();
            }
            else {
                // помечаем путь до корня "грязным"
                let html = this;
                while (html && !html.dirty) {
                    html.dirty = true;
                    //            if (!html.parent) {
                    if (html.isRoot) {
                        if (this.state == State.Destroying) {
                            // отложенное удаление планируем в ближайший кадр, чтобы удаленный элемент как можно скорее пропал из VDOM
                            html.scope.$renderer.queue(html.scope.$renderer.effect(null));
                        }
                        else {
                            // немедленное удаление синхронизируем с патчами, чтобы избежать "моргания"
                            html.scope.$patcher.queue(html.scope.$renderer.effect(null));
                        }
                        //                debugger
                        //                break
                    }
                    html = html.parent;
                }
            }
            defer && defer();
        });
    }
}
